__turbopack_context__.v({
  "animateHorizontal": "animations-module__NVuM5a__animateHorizontal",
  "animateList": "animations-module__NVuM5a__animateList",
  "animateMenu": "animations-module__NVuM5a__animateMenu",
  "css-0": "animations-module__NVuM5a__css-0",
  "css-12": "animations-module__NVuM5a__css-12",
  "css-13": "animations-module__NVuM5a__css-13",
  "css-16": "animations-module__NVuM5a__css-16",
});
